import { BackButtonBar } from "app/components/back-button/back-button.component";
import { useTranslate } from "app/hooks/lang";
import { useNavigateBack } from "app/hooks/navigation.hook";
import useMetaDescription from "app/utils/getMetaDescription";
import Head from "next/head";
import styles from "./privacy-policy.module.scss";
import axios from "axios";
import { useQuery } from "react-query";

export const PrivacyPolicy: React.FC = () => {
  const goBack = useNavigateBack();
  const getMetaDescription = useMetaDescription();
  const response = useQuery("privacy-policy", () =>
    axios.get("/media/docs/Privacy-policy.html")
  );
  const body = response.data?.data
    ? /<body.*?>([\s\S]*)<\/body>/.exec(response.data?.data)
    : null;
  return (
    <>
      <Head>{getMetaDescription()}</Head>
      <div>
        <BackButtonBar onClick={goBack} />
        {body && (
          <div
            className={styles.wrapper}
            dangerouslySetInnerHTML={{ __html: body[1] }}
          ></div>
        )}
      </div>
    </>
  );
};
export default PrivacyPolicy;
